<template>
    <breadCrumbs title="Detailed Course" main="Learning" title1="Detailed Course" />
    <div class="container-fluid">
        <div class="row learning-block">
            <div class="col-xl-9 xl-60 box-col-60">
                <div class="blog-single">
                    <div class="blog-box blog-details">
                        <div class="card"><img class="img-fluid w-100" src="@/assets/images/faq/learning-1.jpg"
                                alt="blog-main">
                            <div class="card-body">
                                <div class="blog-details">
                                    <ul class="blog-social">
                                        <li class="digits">{{ singlecourse.dd }} {{ singlecourse.mm }} {{ singlecourse.yy }}
                                        </li>
                                        <li><i class="icofont icofont-user"></i> {{ singlecourse.author }} </li>
                                        <li class="digits"><i class="icofont icofont-thumbs-up"></i>{{ singlecourse.hits
                                        }}<span>Hits</span>
                                        </li>
                                        <li class="digits"><i class="icofont icofont-ui-chat"></i>{{
                                            singlecourse.comments.length }}
                                            Comments</li>
                                    </ul>
                                    <h4>Knowledge can be defined as awareness of facts or as practical skills. there is wide
                                        agreement among philosophers that it is a form of true belief.</h4>
                                    <div class="single-blog-content-top">
                                        <p>Knowledge can be defined as awareness of facts or as practical skills, and may
                                            also refer to familiarity with objects or situations. Knowledge of facts, also
                                            called propositional knowledge, is often defined as true belief that is distinct
                                            from opinion or guesswork by virtue of justification. While there is wide
                                            agreement among philosophers that it is a form of true belief, many
                                            controversies in philosophy focus on justification: whether it is needed at all,
                                            how to understand it, and whether something else besides it is needed.</p>
                                        <p>Knowledge can be produced in many different ways. The most important source is
                                            perception, which refers to the usage of the five senses. Many theorists also
                                            include introspection as a source of knowledge, not of external physical
                                            objects, but of one's own mental states. Other sources often discussed include
                                            memory, rational intuition, inference, and testimony. According to
                                            foundationalism, some of these sources are basic in the sense that they can
                                            justify beliefs without depending on other mental states. This claim is rejected
                                            by coherentists.</p>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <commentBox />
                </div>

            </div>
            <div class="col-xl-3 xl-40 box-col-40">
                <div class="md-sidebar job-sidebar"><a class="btn btn-primary md-sidebar-toggle" href="javascript:void(0)"
                        @click="collapseFilter()">learning
                        filter</a>
                    <div class="md-sidebar-aside job-left-aside custom-scrollbar" :class="filtered ? 'open' : ''">
                        <div class="default-according style-1  job-accordion" id="accordionoc">
                            <div class="row">
                                <learningtab />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commentBox from "./commentBox.vue"
import learningtab from "./learninglist/learningTab.vue"
import { mapState } from 'vuex';
import router from '@/router';
export default {
    components: {
        learningtab, commentBox
    },
    computed: {
        ...mapState({
            singlecourse: state => state.courses.courses.find(course => {
                if (parseInt(router.currentRoute._rawValue.params.id) === course.id)
                    return course;
            }),
        })
    },
    data() {
        return {
            filtered: false,
        }
    },
    methods: {
        getImgUrl(filename) {
            var images = require.context('../../assets/images/faq/', false, /\.jpg$/);
            return images('./' + filename);
        },
        collapseFilter() {
            this.filtered = !this.filtered;
        },
    }
}
</script>
